"use client";

import { Toaster as Sonner, ToasterProps } from "sonner@2.0.3";

const Toaster = ({ ...props }: ToasterProps) => {
 return (
 <Sonner
 theme="light"
 className="toaster group"
 style={
 {
 "--normal-bg": "var(--popover)",
 "--normal-text": "var(--popover-foreground)",
 "--normal-border": "var(--border)",
 } as React.CSSProperties
 }
 {...props}
 />
 );
};

export { Toaster };
